import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(actionTypes.LOAD_TEAMS, (state, action) => {
      const { response = [] } = action;
      const teams = {};
      response.forEach((team) => {
        teams[team.id] = team;
      });
      return teams;
    })
    .addCase(actionTypes.EDIT_TEAM, (state, action) => {
      const { response = {}, id = 0 } = action;
      const { entities = {} } = response;
      const { teams = {} } = entities;
      if (id) {
        return {
          ...state,
          [id]: teams[id],
        };
      }
      return state;
    })
    .addMatcher(
      (action) => [actionTypes.DELETE_TEAM, actionTypes.DELETE_TEAM_FROM_EVENT_STREAM].includes(action.type),
      (state, action) => {
        const { id = 0 } = action;
        if (id) {
          delete state[id];
        }
        return state;
      }
    )
    .addMatcher(
      (action) => [actionTypes.ADD_TEAM, actionTypes.LOAD_TEAM].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { single: team = {} } = response;
        if (team.id) {
          return {
            ...state,
            [team.id]: team,
          };
        }
        return state;
      }
    )
    .addMatcher(
      (action) => [actionTypes.DELETE_TEAM, actionTypes.DELETE_TEAM_FROM_EVENT_STREAM].includes(action.type),
      (state, action) => {
        const { id = 0 } = action;
        if (id) {
          delete state[id];
        }
        return state;
      }
    )
    .addMatcher(
      (action) =>
        [
          actionTypes.UPDATE_TEAM_FROM_EVENT_STREAM,
          actionTypes.CREATE_TEAM_FROM_EVENT_STREAM,
          actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { teams = {} } = entities;

        return { ...state, ...teams };
      }
    )
    .addMatcher(
      (action) =>
        [
          actionTypes.MOVE_USER_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS,
          actionTypes.USER_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { id: userId = 0 } = action;
        for (const id in state) {
          state[id] = {
            ...state[id],
            members: state[id]?.members.filter((memberId) => memberId !== userId),
          };
        }

        return state;
      }
    );
});

export default reducer;
